import { Form as AntForm, FormItemProps } from 'antd';
import styled, { css } from 'styled-components';
import { HelperText01, Label01, OutlineError } from '../../styles';
import { Input } from '../input/input';

export const StyledForm = styled(AntForm)`
  .ant-form-item {
    padding-bottom: var(--layout-01);
  }

  .ant-form-item-control-input {
    margin-bottom: var(--spacing-02);
  }

  .ant-form-item-has-error {
    ${Input}.ant-input-affix-wrapper,
    ${Input}.ant-input,
    .rte-editor,
    .ant-input-number,
    .custom-input {
      ${OutlineError};
      &:focus {
        box-shadow: none;
        ${OutlineError};
      }
      &:hover {
        ${OutlineError};
      }
    }
    .ant-form-item-extra {
      display: none;
    }
  }

  .ant-form-item-has-feedback {
    .ant-input {
      padding-right: var(--input-height-default);
      &.ant-input-sm {
        padding-right: var(--input-size-sm);
      }
      &.ant-input-lg {
        padding-right: var(--input-height-lg);
      }
    }
    .ant-form-item-children-icon {
      width: var(--input-height-default);
    }
  }

  &.ant-form-small {
    .ant-form-item-has-feedback {
      .ant-form-item-children-icon {
        width: var(--input-size-sm);
      }
    }
  }

  &.ant-form-lg {
    .ant-form-item-has-feedback {
      .ant-form-item-children-icon {
        width: var(--input-height-lg);
      }
    }
  }

  .ant-form-item-label {
    ${Label01};
    color: var(--text-primary);
    padding-bottom: var(--spacing-02);
  }
`;

const { Item } = AntForm;

export const StyledItem = styled(Item)<FormItemProps & { disabled?: boolean }>`
  ${({ disabled }) =>
    disabled
      ? css`
          .ant-form-item-label,
          .ant-form-item-label > label {
            color: var(--text-label-disabled);
          }
          .ant-form-item-explain,
          .ant-form-item-extra {
            color: var(--text-disabled);
          }
        `
      : css`
          .ant-form-item-label,
          .ant-form-item-label > label {
            color: var(--text-primary);
          }
          .ant-form-item-explain,
          .ant-form-item-extra {
            color: var(--text-secondary);
          }
        `}

  .ant-form-item-label,
  .ant-form-item-label > label {
    ${Label01};
    &.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
      ${Label01};
    }
  }
  .ant-form-item-explain,
  .ant-form-item-extra {
    ${HelperText01};

    &.ant-form-item-explain-error {
      color: var(--error-color);
    }
  }
`;

type Form = typeof StyledForm & {
  Item: typeof StyledItem;
};

const Form: Form = StyledForm as any;

Form.Item = StyledItem;

export { Form };
